import * as React from 'react'
import {FC, Fragment, useEffect, useState} from 'react'
import {observer} from 'mobx-react'

///////////////////////////////////////////////////////////////////////////////

export type CountdownProps = {
  counter: number
  onFinish?: () => void
}

///////////////////////////////////////////////////////////////////////////////

export const Countdown: FC<CountdownProps> = observer((props) => {
  const {counter: initialCounter, onFinish} = props
  const [counter, setCounter] = useState(initialCounter)

  useEffect(() => {
    const timerId = setInterval(() => {
      setCounter((counter) => {
        const newCounter = counter - 1

        if (newCounter === 0 && onFinish) {
          onFinish()
        }

        return newCounter
      })
    }, 1000)

    return () => clearInterval(timerId)
  }, [])

  const formatTime = (counter) => {
    const minutes = Math.floor(counter / 60)
    const seconds = counter % 60

    let formattedMinutes = minutes.toString()
    let formattedSeconds = seconds.toString()

    if (minutes < 10) {
      formattedMinutes = '0' + minutes
    }

    if (seconds < 10) {
      formattedSeconds = '0' + seconds
    }

    return [formattedMinutes, formattedSeconds]
  }

  const [minutes, seconds] = formatTime(counter)

  return (
    <Fragment>
      {minutes}:{seconds}
    </Fragment>
  )
})
